import { render, staticRenderFns } from "./initPassWordDialog.vue?vue&type=template&id=4e700e3c&"
import script from "./initPassWordDialog.vue?vue&type=script&lang=ts&"
export * from "./initPassWordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./initPassWordDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports